import React from "react";
import styled from "styled-components";
import logo from "../assets/logo.svg";

function NavbarPc({ show }) {
  return (
    <MainContainer show={show ? "true" : "false"}>
      <Logo src={logo} />
      <TextsContainer>
        <Text href="#home">홈</Text>
        <Text href="#with-js-lap">with js Lap</Text>
        <Text href="#introduction">소개</Text>
        <Text href="#process">프로세스</Text>
        <Text href="#faq">FAQ</Text>
      </TextsContainer>
    </MainContainer>
  );
}

export default NavbarPc;
const MainContainer = styled.div`
  position: fixed;
  top: ${(props) => (props.show === "true" ? 0 : "-62px")};
  width: 90vw;
  margin-left: 5vw;
  height: 91px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  transition: 0.3s ease;
`;
const Logo = styled.img`
  width: 166px;
  height: 36px;
`;
const TextsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
`;
const Text = styled.a`
  cursor: pointer;
  color: #fff;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 200% */
  text-decoration: none;
`;
